import styled, { css } from 'styled-components';

export const PinnedLocation = styled.div`
  display: flex;
  gap: 1rem;
`;

export const PinnedLocationDetails = styled.div`
  display: flex;
  gap: 1rem;
  max-width: 70vw;
  line-height: 1rem;
  align-items: center;
`;

export const IconWrapper = styled.div`
  display: flex;
  height: 40px;
  width: 40px;
  background-color: rgba(0, 0, 0, 0.04);
  border-radius: 60px;
  align-items: center;
  justify-content: center;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-flow: column;
`;

export const PinnedLocationText = css`
  width: 100%;
  font-family: ${Styles.fontFamily.body};
  font-weight: normal;
`;

export const PinnedLocationTitle = styled.div`
  ${PinnedLocationText}
  font-size: 0.9rem;
`;

export const PinnedLocationSubtitle = styled.div`
  ${PinnedLocationText}
  font-size: 0.75rem;
`;
